/*
 *
 * DocumentType constants
 *
 */

export const DRIVER_LICENSE = '2658836640000';
export const PASSPORT = '2658836543000';
export const REQUEST = '4412156042000';
